import http from './http'

export function detectLocale() {
  return http.get('/public/locale', { skipAuthRedirect: true })
}
